
import { Component, Prop, Vue } from "vue-property-decorator"

@Component({})
export default class NotificationsButton extends Vue {
	@Prop({ type: Number, required: true }) numberOfNotifications!: number;

	private get notificationNumberDisplay (): string {
		if (this.numberOfNotifications >= 10) {
			return "9+"
		}
		return this.numberOfNotifications.toString()
	}

	private get hasNotifications (): boolean {
		return this.numberOfNotifications > 0
	}

	private get notificationBadgeClass (): string {
		let classText = this.hasNotifications ? "badge-danger" : "badge-secondary"

		if (this.hasNotifications) {
			classText += " has-notifications"
		}

		return classText
	}
}
